import {lory} from 'lory.js';

const slider = document.querySelector('.js_slider');

if (slider != null) {
    lory(slider, {
        // options going here
    });
}

